import type { HideableNodeType } from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface UpdateTopologyPresetDeviceCommand {
  nodeType: HideableNodeType;
  visible: boolean;
}

export const updateTopologyPresetHideableNode: GraphCommandFactory<
  UpdateTopologyPresetDeviceCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    const { presetDraft } = draft.layoutSettings;

    if (command.visible) {
      presetDraft.hiddenDeviceTypes = presetDraft.hiddenDeviceTypes.filter(
        (deviceType) => deviceType !== command.nodeType,
      );
    } else if (!presetDraft.hiddenDeviceTypes.includes(command.nodeType)) {
      presetDraft.hiddenDeviceTypes.push(command.nodeType);
    }
  });
};
